import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export function SiteNav() {
  const [solid, setSolid] = useState(false);
  const loc = useLocation();
  const onLanding = loc.pathname === "/";

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const dark = onLanding && !solid;

  return (
    <nav
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        solid || !onLanding ? "bg-cream/90 backdrop-blur border-b border-sylhet-forest/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-content mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <span className="relative w-7 h-7 rounded-full overflow-hidden bg-sylhet-forest grid place-items-center">
            <span className="w-4 h-4 rounded-full bg-sylhet-red group-hover:scale-110 transition-transform" />
          </span>
          <span className={`font-display font-extrabold tracking-tight text-lg ${dark ? "text-cream" : "text-charcoal"}`}>
            Made in Sylhet
          </span>
        </Link>

        <div className="flex items-center gap-1.5 md:gap-3">
          <Link
            to="/about"
            data-testid="nav-about"
            className={`hidden sm:inline-block px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              dark ? "text-cream/90 hover:text-cream" : "text-charcoal/80 hover:text-charcoal"
            }`}
          >
            About
          </Link>
          {!onLanding && (
            <Link
              to="/admin"
              data-testid="nav-admin"
              className={`hidden sm:inline-block px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                dark ? "text-cream/70 hover:text-cream" : "text-charcoal/60 hover:text-charcoal"
              }`}
            >
              Admin
            </Link>
          )}
          <Link
            to="/submit"
            data-testid="nav-submit-cta"
            className="px-5 py-2.5 rounded-full bg-sylhet-red text-cream text-sm font-semibold hover:-translate-y-0.5 hover:shadow-lg transition-all"
          >
            Submit Reel
          </Link>
        </div>
      </div>
    </nav>
  );
}
